import _ from "lodash"

export const WuenscheUndZieleActions = ({getDataFromPointer, updateData}) => {

    return {
        OPEN_WUNSCH_MODAL: ({item, containerId, savePointer}) => {
            updateData(item?.answers, "/wuenscheUndZiele/answers")
            updateData({...item, containerId, savePointer}, "/wuenscheUndZiele/fragenObjekt")
            updateData(true, "/wuenscheUndZiele/modalOpen")
        },
        CLOSE_WUNSCH_MODAL: () => {
            const answers = getDataFromPointer("/wuenscheUndZiele/answers")
            const fragenObjekt = getDataFromPointer("/wuenscheUndZiele/fragenObjekt")
            const currentItemWithAnswers = {...fragenObjekt, answers: answers}
            const containers = getDataFromPointer(fragenObjekt.savePointer)

            const newContainers = {
                ...containers,
                [currentItemWithAnswers.containerId]: containers[currentItemWithAnswers.containerId].map(item => item.id === currentItemWithAnswers.id ? currentItemWithAnswers : item),
            }

            updateData(newContainers, fragenObjekt.savePointer)

            updateData(null, "/wuenscheUndZiele/fragenObjekt")
            updateData(null, "/wuenscheUndZiele/answers")
            updateData(false, "/wuenscheUndZiele/modalOpen")
        },
        REMOVE_WUNSCH: ({containerId, itemId, containers, pointer}) => {
            const item = containers[containerId].find((i) => i.id === itemId)
            if (!item) return containers
            const unasignedItem = _.omit(item, ["x", "y", "answers"])
            const mutatedState = {
                ...containers,
                [containerId]: containers[containerId].filter((i) => i.id !== itemId),
                unassigned: [...containers.unassigned, unasignedItem],
            }

            updateData(mutatedState, pointer)
        }
    }
}